import Country from '~/Api/Country/Country';
import RequiredLicenses from '~/Api/DataSource/RequiredLicenses';

import ProductDataset from './ProductDataset';
import ProductDatasetSource from './ProductDatasetSource';

interface RawProductDataset {
	source: {
		type: string;
		description: string;
		shortName: string;
		country: { alpha2: string; name: string };
		singleUnitPackageSize: boolean;
		requiresLicence: { prices: boolean };
	};
	productRetrievedAt: string | null;
	productUpdatedAt: string | null;
	validFrom: string | null;
}

export default function mapProductDataset(dataset: RawProductDataset): ProductDataset {
	return new ProductDataset(
		new ProductDatasetSource(
			dataset.source.type,
			dataset.source.description,
			dataset.source.shortName,
			new Country(dataset.source.country.alpha2, dataset.source.country.name),
			dataset.source.singleUnitPackageSize,
			new RequiredLicenses(dataset.source.requiresLicence.prices)
		),
		dataset.productRetrievedAt !== null ? new Date(dataset.productRetrievedAt) : null,
		dataset.validFrom !== null ? new Date(dataset.validFrom) : null,
		dataset.productUpdatedAt !== null ? new Date(dataset.productUpdatedAt) : null
	);
}
